import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { socialLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy social envelope.
 *
 * `type: z.literal('zero')` is required here (no `.optional()`): a social
 * widget created inside a zero block must carry the tag end-to-end so that
 * downstream consumers (positioning hosts, render branches) can recognise
 * the placement. The host-app factory copies `meta.type` onto the entity at
 * creation time; missing-tag entities are validation errors against this
 * branch by design.
 *
 * Inner data uses {@link socialLegacyZeroDataSchema} — the extended-position
 * grid instead of the default variant's simple per-device grid.
 */
export const socialLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('social-networks'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: socialLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
